import { diffBetweenDates } from './date';

const isFirstShowDateValidForConnectivityPopup = firstShowDate => {
  if (!firstShowDate) {
    return true;
  }
  const JUNE_10_TH = new Date(2024, 5, 10);

  return diffBetweenDates(firstShowDate, JUNE_10_TH)?.days > 0;
};

export {
  isFirstShowDateValidForConnectivityPopup,
};
